import { Button } from "./Button";
import { common } from "../../copy/sq";

/**
 * A per-section failure state — never a full-page crash. Message is
 * always a short, user-safe string (the API client already strips any
 * server-side stack trace/internal detail before this component ever
 * sees it — see api/client.ts).
 */
export function ErrorState({
  title = "Ky seksion nuk u ngarkua dot",
  message,
  onRetry,
}: {
  title?: string;
  message?: string;
  onRetry?: () => void;
}) {
  return (
    <div className="flex flex-col items-start gap-2 rounded-xl2 border border-signal-bad-bg bg-signal-bad-bg/40 px-5 py-4">
      <p className="text-sm font-medium text-signal-bad">{title}</p>
      {message ? <p className="text-sm text-ink-600">{message}</p> : null}
      {onRetry ? (
        <Button variant="secondary" onClick={onRetry} className="mt-1">
          {common.retry}
        </Button>
      ) : null}
    </div>
  );
}
